// Polis in the new, pared-down interface (10 October 2026): the "The election"
// tab (`components/epure/polis/EPolisScrutin.vue`). Its rules, its calendar,
// the campaign the twins read, the lists by bloc, re-running the preparation
// and editing the lists.
export default {
  chargement: 'Loading…',
  erreur: {
    lecture: 'Could not load',
    reessayer: 'Try again',
    fermer: 'close',
  },
  actions: {
    relancer: 'Re-run the preparation',
    modifierListes: 'Edit the lists',
    modifierCandidats: 'Edit the candidates',
  },
  regles: {
    titre: 'The rules',
  },
  calendrier: {
    titre: 'Key dates',
    aujourdhui: 'Today',
    jourDuVote: 'Election day',
    compte: {
      aujourdhui: 'today',
      demain: 'tomorrow',
      dans: 'in {n} days',
      passe: 'past',
    },
  },
  campagne: {
    titre: 'The campaign, as of {date}',
    titreSansDate: 'The campaign',
    source: 'written by Orion from public sources, without a single poll',
    lireTout: 'Read the whole campaign',
    replier: 'Collapse the campaign',
    recomposition: 'What became of the previous election’s parties | What became of the previous election’s party | What became of the previous election’s {n} parties',
  },
  listes: {
    titreListes: 'No lists | The list | The {n} lists',
    titreCandidats: 'No candidates | The candidate | The {n} candidates',
    aide: 'click to open the campaign profile the twins read',
    horsBlocs: 'Outside the blocs',
    aucuneListe: 'No lists for this election.',
    aucunCandidat: 'No candidates for this election.',
  },
  relance: {
    titre: 'Re-run the preparation',
    aide: 'Orion researches this election again: the lists or candidates, their profiles, the state of the campaign.',
    consignes: 'What you want to project',
    placeholder: 'One candidate per camp; or a scenario: this candidate runs, that one does not',
    lancer: 'Orion researches again',
    annuler: 'Cancel',
  },
  edition: {
    titreListes: 'Edit the lists',
    inscrits: 'Registered voters',
    inscritsExemple: '50,187,093',
    blancsNuls: 'Blank and void ballots, % of votes cast',
    titreCandidats: 'Edit the candidates',
    aide: 'What the twins read before voting: the profiles and the state of the campaign.',
    nouvelleListe: 'New list',
    nouveauCandidat: 'New candidate',
    supprimerListe: 'Delete the list {nom}',
    supprimerCandidat: 'Remove the candidate {nom}',
    nom: 'Name',
    teteDeListe: 'List leader',
    partiOuSoutien: 'Party or backing',
    bloc: 'Bloc',
    fiche: 'In one sentence',
    fichePlaceholder: 'Who they are and where they stand, in one sentence',
    ficheCampagne: 'Campaign profile',
    ficheCampagnePlaceholder: 'Their campaign: who backs them, their positions, their alliances, a recent highlight',
    ajouterListe: 'Add a list',
    ajouterCandidat: 'Add a candidate',
    campagne: 'The state of the campaign',
    auMoinsDeuxListes: 'At least two named lists are needed to save.',
    auMoinsDeuxCandidats: 'At least two named candidates are needed to save.',
    annuler: 'Cancel',
    enregistrer: 'Save',
  },
}
